import { lazy, Suspense, useRef } from 'react'
import { Route, Routes, useLocation, type Location } from 'react-router-dom'
import LoadingRing from '../../components/shared/LoadingRing.jsx'
import { t } from '../store-language/i18n.ts'

const ShowroomModule = lazy(function () { return import('./ShowroomModule.tsx') })

/** One renderer per verified agency session, mounted lazily on the first visit. */
export default function RetainedShowroom({ active, companyInfo }: {
  active: boolean
  companyInfo: { title?: string; fileId?: string | number } | null
}) {
  const location = useLocation()
  const lastVisit = useRef<Location>()
  if (active) {
    lastVisit.current = location.state == null && lastVisit.current
      ? { ...location, state: lastVisit.current.state }
      : location
  }

  return (
    <div
      className="showroom-retained"
      hidden={!active}
      aria-hidden={!active}
    >
      {lastVisit.current && (
        <Suspense fallback={<LoadingRing tip={t('در حال بارگذاری نمایشگاه…')} />}>
          <Routes location={lastVisit.current}>
            <Route
              path="/showroom/*"
              element={
                <ShowroomModule
                  active={active}
                  companyInfo={companyInfo}
                />
              }
            />
          </Routes>
        </Suspense>
      )}
    </div>
  )
}
